module.exports = __webpack_public_path__ + "static/media/flower7.a34b2b79.png";